import { createSlice } from '@reduxjs/toolkit'

// sessionStorage can hold a chain from a previous chainid; if it doesn't match
// the current URL's chainid, discard it so components don't briefly render/fetch
// with the wrong chain before App.js resolves and dispatches the correct one.
const getInitialChain = () => {
  const cached = sessionStorage.getItem("chain");
  if (!cached) return null;

  const chainIdParam = new URLSearchParams(window.location.search).get("chainid");
  const cachedChain = JSON.parse(cached);

  if (chainIdParam && cachedChain?.chainId != chainIdParam) {
    sessionStorage.removeItem("chain");
    return null;
  }

  return cachedChain;
};

export const chainReducer = createSlice({
  name: 'chain',
  initialState: getInitialChain(),
  reducers: {
    setChain: (state, action) => {
      state = action.payload
      if (!action.payload) {
        sessionStorage.removeItem("chain")
      } else {
        sessionStorage.setItem("chain", JSON.stringify(action.payload))
      }
      return state;
    },
  },
})

export const { setChain } = chainReducer.actions

export default chainReducer.reducer